import { useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
interface Proposal {
    account_name: string;
    order_name_c: string;
    id: number;
    start_date: string;
    end_date: string;
    user_name: string;
    amount: number;
    status: string;
    manual_order : number;
}
interface Invoies {
    order_name: string;
    id: number;
    invoice_create_date: string;
    invoice_due_date: string;
    invoice_amount: number;
    invoice_number: string;
    paid_amount: number;
    s3_link : string;
}
const ExpandedComponent = ({ data }: { data: Proposal & { invoices: Invoies[] } }) => {
    const { invoices } = useSelector((state: any) => state.invoices);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const columns = [
        {
            name: "",
            width: '5%',
            cell: (row: Invoies) => (
                <div className="d-flex">
                    <button
                        style={{ border: "none", backgroundColor: "transparent", }}
                        title="Download Invoice"  
                    >
                        <a href={row.s3_link}><i className="fa fa-download font-size-16 me-1"></i></a>
                    </button>
                </div>
            )
        },
        {
            name: "Invoice Number",
            selector: (row: Invoies) => "#" + row.invoice_number,
            sortable: true,
            width: '14%',
        },
        {
            name: "Invoice Name",
            selector: (row: Invoies) => row.order_name,
            sortable: true,
            width: '45%',
        },

        {
            name: "Date Issue",
            selector: (row: Invoies) => row.invoice_create_date,
            sortable: true,
            width: '10%',
        },
        {
            name: "Due Date",
            selector: (row: Invoies) => row.invoice_due_date,
            sortable: true,
            width: '10%',
        },
        {
            name: "Invoice Total",
            selector: (row: Invoies) =>
                new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row.invoice_amount),
            sortable: true,
            width: '12%',
        }
    ];
    const customStyles = {
        table: {
            style: {
                border: 'none',
                // borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#f1f3f5',
                fontSize: '12px',
                fontWeight: '600',
                color: '#343a40',
                borderBottom: '1px solid #e0e0e0',
            },
        },
        headCells: {
            style: {
                paddingTop: '12px',
                paddingBottom: '12px',
                paddingLeft: '20px',
                paddingRight: '20px',
            },
        },
        rows: {
            style: {
                fontSize: '14px',
                color: '#495057',
                backgroundColor: '#ffffff',
                minHeight: '48px',
                borderBottom: '1px solid #f1f3f5',
                transition: 'background-color 0.2s ease-in-out',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer',
                },
            },
        },
        cells: {
            style: {
                paddingLeft: '20px',
                paddingRight: '20px',
            },
        },
    };

    const filteredInvoices = data?.invoices
        .filter((invoice: any) => {
            const orderName = invoice.order_name ? invoice.order_name.toLowerCase() : "";
            return (
                orderName.includes(searchTerm.toLowerCase())
            );
        });
    return (
        <div>
            <DataTable
                className="data-table"
                columns={columns}
                data={filteredInvoices}
                // pagination
                // highlightOnHover
                responsive
                customStyles={customStyles}
            />
        </div>
    );
};
export default ExpandedComponent;
